import styled from 'styled-components';
import { WarningOutlined } from '@ant-design/icons';

export const StyledDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-flow: row wrap;
  gap: ${({ theme }) => theme.spacing.space_4};
  font-size: ${({ theme }) => theme.font.size.large};
`;

export const StyledWarningOutline = styled(WarningOutlined)`
  color: var(--primary-color);
`;
